import { BaseClient } from '../base-client';
import type { AuditListItem, ListAuditQuery } from './types';

type ListResponse = {
  data: AuditListItem[];
  meta: { total: number; limit: number; offset: number };
};

export class AuditClient extends BaseClient {
  /**
   * Unified audit read. Pass no entity filter for the platform-wide log, or
   * `entityType` + `entityId` for a single object's history — same response
   * shape either way. Returns rows enriched with identifying + actor labels.
   */
  list(query: ListAuditQuery = {}): Promise<ListResponse> {
    return this.request('/api/audit', { query: normalize(query) });
  }
}

function normalize(q: object): Record<string, string | number | boolean | undefined> {
  const out: Record<string, string | number | boolean | undefined> = {};
  for (const [k, v] of Object.entries(q)) {
    if (v === undefined || v === '') continue;
    if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
      out[k] = v;
    }
  }
  return out;
}
